import $ from 'jquery'
import 'select2/dist/css/select2.css'
import 'select2'

// $('body').on('DOMNodeInserted', 'select', function () {
//     $(this).select2();
// });
$( document ).on('turbolinks:load', function() {
  $(document).on('select2:open', e => {
    const id = e.target.id;
    const target = document.querySelector(`[aria-controls=select2-${id}-results]`);
    target.focus();
  });

  $('.offline_member_search').select2({});

  function ts_select2_members(elem){
    console.log("adas ",elem)
    elem.select2({
      ajax: {
        url: "/associations/memberships/membership_livesearch",
        method: "GET",
        dataType: 'json',
        delay: 500,
        data: function (params) {
          console.log(elem)

          return {
            member_name: params.term, // search term
             // search term
          };
        },

        processResults: function (data, params) {
          return {
            results: data.data
          };
        },
        cache: true
      },

      placeholder: 'Select a membership',
      minimumInputLength: 3,
      templateResult: formatRepo,
      templateSelection: formatRepoSelection
    });
  }

  $(document).on('click', '.add_fields', function(){
    console.log('add fields clicked')
    var elems = $(".member_search")
    elems.each(function(){
      if(!$(this).hasClass('select2-hidden-accessible')){
        ts_select2_members($(this));
      }
    })
  });


  var elems = $(".member_search")
  elems.each(function(){
    console.log("aa lem atr", $(this).attr("data-level"))
    ts_select2_members($(this));
  })

  function formatRepo (repo) {
    if (repo.loading) {
      return repo.text;
    }

    var $container = $(
      "<div class='select2-member clearfix'>" +
        "<div class='select2-member_name'></div>" +
      "</div>"
    );

    $container.find(".select2-member_name").text(repo.member_name);
    return $container;
  }

  function formatRepoSelection (repo) {
    // 1. If it's a new result from AJAX, it will have 'member_name'
    if (repo.member_name) {
      return repo.member_name;
    }
    // 2. If it's existing data (on Edit page), it uses the 'text' property
    return repo.text || "Select a membership";
  }
});
// Remove Select2 instances before caching the page to ensure a clean state on the next load.
$(document).on("turbolinks:before-cache", function () {
  $(".select2-hidden-accessible").select2("destroy");
});
